{
  "en": {
    "en-GB": "English",
    "en-AU": "English (Australia)",
    "default": "en-GB"
  },
  "fr": {
    "fr-FR": "Français",
    "default": "fr-FR"
  }
}
